import React, { Component } from 'react';
import {
  Button,
  Spin,
  Modal,
  Form,
  Input,
  Select,
  Tag,
  message,
  Popconfirm,
  Empty,
} from 'antd';
import {
  TeamOutlined,
  UserOutlined,
  PlusOutlined,
  ClockCircleOutlined,
  ContactsOutlined,
} from '@ant-design/icons';
import PortalLayout from '../../components/portal';
import { get, post } from '../../commons/http';
import styles from './style.less';

const { Option } = Select;
const { TextArea } = Input;

const TYPE_MAP = {
  recruit: { text: '队长招募', color: '#2b7cd3', bg: '#e3f0fb' },
  seek: { text: '找队伍', color: '#1f9d8f', bg: '#e0f5f2' },
};

function timeAgo(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return '刚刚';
  if (min < 60) return `${min} 分钟前`;
  const hour = Math.floor(min / 60);
  if (hour < 24) return `${hour} 小时前`;
  const day = Math.floor(hour / 24);
  if (day < 30) return `${day} 天前`;
  return new Date(dateStr).toLocaleDateString();
}

/**
 * 组队求助：浏览公开，发布需登录
 */
export default class TeamBoard extends Component {
  state = {
    posts: [],
    competitions: [],
    loading: true,
    filter: 'all', // all | recruit | seek
    modalVisible: false,
    submitting: false,
  };

  formRef = React.createRef();

  componentDidMount() {
    this.fetchPosts();
    this.fetchCompetitions();
  }

  getUser = () => {
    try {
      const token = window.localStorage.getItem('token');
      const user = JSON.parse(window.localStorage.getItem('user') || 'null');
      if (token && user && user.id) return user;
    } catch (e) {}
    return null;
  };

  fetchPosts = async () => {
    try {
      const res = await get('/teamPost/list');
      if (res.code === 0) {
        this.setState({ posts: res.data.posts || [], loading: false });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  fetchCompetitions = async () => {
    try {
      const res = await get('/competition/all');
      if (res.code === 0) {
        this.setState({
          competitions: (res.data.competitions || []).filter(
            (c) => c.status === 1 || c.status === 0
          ),
        });
      }
    } catch (e) {}
  };

  handlePublish = () => {
    if (!this.getUser()) {
      message.info('请先登录后再发布', 2);
      this.props.history.push('/login');
      return;
    }
    this.setState({ modalVisible: true });
  };

  handleSubmit = async () => {
    try {
      const values = await this.formRef.current.validateFields();
      this.setState({ submitting: true });
      const res = await post('/teamPost/create', values);
      this.setState({ submitting: false });
      if (res.code === 0) {
        message.success('发布成功', 1.5);
        this.setState({ modalVisible: false });
        this.formRef.current.resetFields();
        this.fetchPosts();
      } else {
        message.error(res.msg || '发布失败', 2);
      }
    } catch (e) {
      this.setState({ submitting: false });
    }
  };

  handleToggle = async (post) => {
    const res = await post('/teamPost/toggle', { id: post._id });
    if (res.code === 0) {
      message.success(res.msg, 1.5);
      this.fetchPosts();
    } else {
      message.error(res.msg || '操作失败', 2);
    }
  };

  handleDelete = async (post) => {
    const res = await post('/teamPost/delete', { id: post._id });
    if (res.code === 0) {
      message.success('已删除', 1.5);
      this.fetchPosts();
    } else {
      message.error(res.msg || '删除失败', 2);
    }
  };

  getFiltered = () => {
    const { posts, filter } = this.state;
    let list = posts;
    if (filter !== 'all') {
      list = list.filter((p) => p.type === filter);
    }
    // 开放的排前面，已关闭沉底
    return list.sort((a, b) => {
      if (a.status === b.status) return 0;
      return a.status === 'open' ? -1 : 1;
    });
  };

  render() {
    const { loading, filter, modalVisible, submitting, competitions } =
      this.state;
    const user = this.getUser();
    const list = this.getFiltered();

    return (
      <PortalLayout>
        <div className={styles.container}>
          <div className={styles.head}>
            <h1 className={styles.title}>组队求助</h1>
            <p className={styles.subtitle}>
              队长发布招募，同学寻找队伍，快速组建你的参赛团队
            </p>
          </div>

          <div className={styles.toolbar}>
            <div className={styles.tabs}>
              {[
                { key: 'all', text: '全部' },
                { key: 'recruit', text: '队长招募' },
                { key: 'seek', text: '找队伍' },
              ].map((t) => (
                <button
                  key={t.key}
                  className={`${styles.tab} ${
                    filter === t.key ? styles.active : ''
                  }`}
                  onClick={() => this.setState({ filter: t.key })}
                >
                  {t.text}
                </button>
              ))}
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={this.handlePublish}
              className={styles['publish-btn']}
            >
              发布组队信息
            </Button>
          </div>

          {loading ? (
            <div className={styles.loading}>
              <Spin size="large" />
            </div>
          ) : list.length > 0 ? (
            <div className={styles.list}>
              {list.map((p) => {
                const tm = TYPE_MAP[p.type];
                const isMine = user && p.author && p.author._id === user.id;
                const closed = p.status === 'closed';
                return (
                  <div
                    key={p._id}
                    className={`${styles.card} ${closed ? styles.closed : ''}`}
                  >
                    <div className={styles['card-head']}>
                      <Tag
                        color={tm.bg}
                        style={{ color: tm.color, border: 'none' }}
                      >
                        {tm.text}
                      </Tag>
                      <span className={styles['card-competition']}>
                        {p.competition ? p.competition.title : '未知赛事'}
                      </span>
                      {closed && (
                        <span className={styles['closed-tag']}>已截止</span>
                      )}
                      <span className={styles['card-time']}>
                        <ClockCircleOutlined /> {timeAgo(p.createdAt)}
                      </span>
                    </div>
                    <h3 className={styles['card-title']}>{p.title}</h3>
                    {p.content && (
                      <p className={styles['card-content']}>{p.content}</p>
                    )}
                    <div className={styles['card-foot']}>
                      <span className={styles['card-author']}>
                        <UserOutlined /> {p.author ? p.author.name : '匿名'}
                        {p.author && p.author.staffId
                          ? ` (${p.author.staffId})`
                          : ''}
                      </span>
                      <span className={styles['card-contact']}>
                        <ContactsOutlined /> {p.contact}
                      </span>
                      {isMine && (
                        <span className={styles['card-actions']}>
                          <Button
                            type="link"
                            size="small"
                            onClick={() => this.handleToggle(p)}
                          >
                            {closed ? '重新开启' : '关闭'}
                          </Button>
                          <Popconfirm
                            title="确定删除这条帖子吗？"
                            okText="删除"
                            cancelText="取消"
                            onConfirm={() => this.handleDelete(p)}
                          >
                            <Button type="link" size="small" danger>
                              删除
                            </Button>
                          </Popconfirm>
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <Empty
              description="暂无组队信息，来发布第一条吧"
              style={{ padding: '60px 0' }}
            />
          )}
        </div>

        <Modal
          title="发布组队信息"
          visible={modalVisible}
          onOk={this.handleSubmit}
          onCancel={() => this.setState({ modalVisible: false })}
          confirmLoading={submitting}
          okText="发布"
          cancelText="取消"
          destroyOnClose
        >
          <Form ref={this.formRef} layout="vertical">
            <Form.Item
              name="type"
              label="类型"
              rules={[{ required: true, message: '请选择类型' }]}
            >
              <Select placeholder="你是队长还是队员？">
                <Option value="recruit">
                  <TeamOutlined /> 我是队长，招募队员
                </Option>
                <Option value="seek">
                  <UserOutlined /> 我是队员，寻找队伍
                </Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="competitionId"
              label="关联赛事"
              rules={[{ required: true, message: '请选择赛事' }]}
            >
              <Select placeholder="选择要参加的赛事">
                {competitions.map((c) => (
                  <Option key={c._id} value={c._id}>
                    {c.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="title"
              label="标题"
              rules={[
                { required: true, message: '请填写标题' },
                { max: 50, message: '标题不超过50字' },
              ]}
            >
              <Input placeholder="例如：制图组缺1人，求GIS专业队友" />
            </Form.Item>
            <Form.Item
              name="content"
              label="补充说明"
              rules={[{ max: 500, message: '不超过500字' }]}
            >
              <TextArea
                rows={3}
                placeholder="介绍一下你们的情况、对队友的要求等"
              />
            </Form.Item>
            <Form.Item
              name="contact"
              label="联系方式"
              rules={[
                { required: true, message: '请填写联系方式' },
                { max: 50, message: '不超过50字' },
              ]}
            >
              <Input placeholder="QQ / 微信 / 邮箱，方便对方联系你" />
            </Form.Item>
          </Form>
        </Modal>
      </PortalLayout>
    );
  }
}
